import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  CustomFieldControl,
  CustomFieldsFragment,
} from '@vendure/admin-ui/core';

@Component({
  templateUrl: './hidden-component.html',
  styleUrls: ['./hidden-component.scss'],
})
export class HiddenComponent implements CustomFieldControl {
  isListInput?: boolean | undefined;
  readonly: boolean;
  formControl: FormControl<any>;
  config: CustomFieldsFragment;
}
